var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dev-history-root"},[_c('div',{staticClass:"root-scrollbar root"},[(_vm.imageUrl)?_c('img',{class:_vm.language == 'en-US' ? 'area-layout-en' : 'area-layout',attrs:{"src":_vm.imageUrl,"alt":""}}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }